import React from "react";
import PropTypes from "prop-types";
import { dateTimeToStringWithNumOfDays } from "components/Shared/Formatters";
import MCard from "components/Shared/MCard.tsx";

const isNull = field => (field ? field : "n/a");
class LoginActivity extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const loginStatistics = this.props.loginStatistics ? this.props.loginStatistics : {};
    const LastLoginDate = loginStatistics ? (!loginStatistics.lastLoginDate ? "n/a" : dateTimeToStringWithNumOfDays(loginStatistics.lastLoginDate)) : "n/a";

    let fields = [
      { label: "Last Login Day", value: LastLoginDate },
      { label: "Failed Login Attempts", value: loginStatistics.failedAttempts },
      { label: "Past 7 Days", value: loginStatistics.countInLast7Days },
      { label: "Past 14 Days", value: loginStatistics.countInLast14Days },
      { label: "Past 30 Days", value: loginStatistics.countInLast30Days },
      { key: "loginSpread", control: (
        <section className="card-vertical-table">
          <div className="daily-log-container">
            <div className="day-container">
              <div className="day">Sun</div>
              <div className="day-time">{isNull(loginStatistics.countSunday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Mon</div>
              <div className="day-time">{isNull(loginStatistics.countMonday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Tue</div>
              <div className="day-time">{isNull(loginStatistics.countTuesday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Wed</div>
              <div className="day-time">{isNull(loginStatistics.countWednesday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Thu</div>
              <div className="day-time">{isNull(loginStatistics.countThursday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Fri</div>
              <div className="day-time">{isNull(loginStatistics.countFriday)}</div>
            </div>
            <div className="day-container">
              <div className="day">Sat</div>
              <div className="day-time">{isNull(loginStatistics.countSaturday)}</div>
            </div>
          </div>
        </section>) }
    ];

    return (
      <MCard
        title="Login Activity"
        fields={fields}
        className={this.props.className}
      />
    );
  }
}

LoginActivity.propTypes = {
  loginStatistics: PropTypes.object,
  className: PropTypes.string,
};

export default LoginActivity;
